import {
  createContext,
  useCallback,
  useContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import type { Order } from '../types/order';
import { buildInitialOrders, newOrderId } from '../types/order';

type OrdersCatalogContextValue = {
  orders: Order[];
  setOrders: Dispatch<SetStateAction<Order[]>>;
  addOrder: (order: Omit<Order, 'id' | 'createdAt'>) => void;
};

const OrdersCatalogContext = createContext<OrdersCatalogContextValue | null>(null);

export function OrdersCatalogProvider({ children }: { children: ReactNode }) {
  const [orders, setOrders] = useState<Order[]>(buildInitialOrders);

  const addOrder = useCallback((order: Omit<Order, 'id' | 'createdAt'>) => {
    const next: Order = {
      ...order,
      lines: order.lines.map((line) => ({ ...line })),
      id: newOrderId(),
      createdAt: new Date().toISOString(),
    };
    setOrders((prev) => [next, ...prev]);
  }, []);

  return (
    <OrdersCatalogContext.Provider value={{ orders, setOrders, addOrder }}>{children}</OrdersCatalogContext.Provider>
  );
}

export function useOrdersCatalog(): OrdersCatalogContextValue {
  const ctx = useContext(OrdersCatalogContext);
  if (!ctx) {
    throw new Error('useOrdersCatalog debe usarse dentro de OrdersCatalogProvider');
  }
  return ctx;
}
